
    const data = {"name":"src/core/icons/checkbox-blank-circle","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            